import { CSSProperties, FC } from 'react'
import { TextLabelBox, TextLabelSecond } from './TextLabel.styled'

type Props = {
    design_type?: number
    style?: CSSProperties
}

export const TextLabel: FC<Props> = ({ design_type, style }) => {
    return (
        <TextLabelBox design_type={design_type} style={style}>
            Made with love{' '}
            <TextLabelSecond href="https://boostinglead.com/" target="_blank">
                BoostingLead
            </TextLabelSecond>
        </TextLabelBox>
    )
}
